import React from "react";
import { useTokenRefresh } from "@/hooks/use-token-refresh";

/**
 * Componente que maneja la renovación automática de tokens
 * Debe estar dentro del AuthProvider para acceder al contexto
 */
export const TokenRefreshProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  // Hook para renovación automática de tokens
  useTokenRefresh();

  return <>{children}</>;
};
